export default __webpack_public_path__ + "static/media/34.4be8727a.jpeg";